<template>
  <div>
    <mdb-container>
      <mdb-row>
        <mdb-col md="4" class="mb-5 d-flex">
          <mdb-card narrow>
            <mdb-view hover cascade>
              <mdb-card-image :src="require('../assets/images/ca/1.jpg')" alt="Card image cap"></mdb-card-image>
              <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
            </mdb-view>
            <mdb-card-body class="text-center" cascade>
              <mdb-card-title><strong>加拿大</strong></mdb-card-title>
              <h5 class="dark-grey-text"><strong>魁省投资移民项目</strong></h5>
              <mdb-card-text>没有学历、语言硬性要求<br/>无需自营生意，一步到位获枫叶卡
              </mdb-card-text>
              <mdb-btn outline="warning" class="font-weight-bolder" @click="$router.push('/ca/cakui')">查看详情</mdb-btn>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>


        <mdb-col md="4" class="mb-5 d-flex">
          <mdb-card narrow>
            <mdb-view hover cascade>
              <mdb-card-image :src="require('../assets/images/ca/11.jpg')" alt="Card image cap"></mdb-card-image>
              <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
            </mdb-view>
            <mdb-card-body class="text-center" cascade>
              <mdb-card-title><strong>加拿大</strong></mdb-card-title>
              <h5 class="dark-grey-text"><strong>联邦创业移民项目(SUV)</strong></h5>
              <mdb-card-text>对学历和工作经验无硬性要求<br/>无需省里审批、一步到位获得永居
              </mdb-card-text>
              <mdb-btn outline="info" class="font-weight-bolder" @click="$router.push('/ca/casuv')">查看详情</mdb-btn>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>


        <mdb-col md="4" class="mb-5  d-flex">
          <mdb-card narrow>
            <mdb-view hover cascade>
              <mdb-card-image :src="require('../assets/images/ca/index7.jpg')" alt="Card image cap"></mdb-card-image>
              <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
            </mdb-view>
            <mdb-card-body v-animateOnScroll="{animation: 'rotateInUpLeft', delay: 0}" class="text-center" cascade>
              <mdb-card-title><strong>加拿大</strong></mdb-card-title>
              <h5 class="dark-grey-text"><strong>BC省企业家移民试点项目</strong></h5>
              <mdb-card-text>史上要求最低<br/>全家移民仅需10万加币
              </mdb-card-text>
              <mdb-btn outline="secondary" class="font-weight-bolder" @click="$router.push('/ca/cabc')">查看详情</mdb-btn>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>


      </mdb-row>
    </mdb-container>


    <mdb-container>
      <mdb-row>

        <mdb-col md="4" class="mb-5 d-flex">
          <mdb-card cascade>
            <mdb-view hover cascade>
              <mdb-card-image :src="require('../assets/images/ca/index8.jpg')" alt="Card image cap"></mdb-card-image>
              <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
            </mdb-view>
            <mdb-card-body v-animateOnScroll="{animation: 'bounceInLeft', delay: 0}" class="text-center" cascade>
              <mdb-card-title><strong>加拿大</strong></mdb-card-title>
              <h5 class="dark-grey-text"><strong>萨省企业家移民项目</strong></h5>
              <mdb-card-text>资产要求低，投资成本少<br/>申请门槛低，项目周期短
              </mdb-card-text>
              <mdb-btn outline="danger" class="font-weight-bolder" @click="$router.push('/ca/casa')">查看详情</mdb-btn>

            </mdb-card-body>
          </mdb-card>
        </mdb-col>
        <mdb-col md="4" class="mb-5 d-flex">
          <mdb-card narrow>
            <mdb-view hover cascade>
              <mdb-card-image :src="require('../assets/images/ca/13.jpg')" alt="Card image cap"></mdb-card-image>
              <mdb-mask flex-center waves overlay="white-slight"></mdb-mask>
            </mdb-view>
            <mdb-card-body class="text-center" cascade>
              <mdb-card-title><strong>加拿大</strong></mdb-card-title>
              <h5 class="dark-grey-text"><strong>曼省留学移民项目</strong></h5>
              <mdb-card-text>保证工作机会，确保曼省省政府递交移民的资格<br/>整体申请时间较快<br/>
                真实带薪工作，移民前可收入3万加币
              </mdb-card-text>
              <mdb-btn outline="primary" class="font-weight-bolder" @click="$router.push('/ca/caman')">查看详情</mdb-btn>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

        <mdb-col md="4" class="mb-5 d-flex">
          <mdb-card narrow>
            <mdb-view gradient="heavy-rain" class="black-text" cascade>
              <h2 class="card-header-title mb-3">联邦自雇移民项目</h2>
              <p class="mb-0">
                <mdb-icon icon="location"/>
                加拿大
              </p>
            </mdb-view>
            <mdb-card-body v-animateOnScroll="{animation: 'rotateInUpLeft', delay: 0}" class="" cascade>
              <mdb-card-text class="text-monospace">
                <mdb-icon class="fas fa-quote-left"></mdb-icon>
                加拿大联邦自雇移民项目是文化体育艺术工作者通往加拿大的捷径，主要适用于那些可以在文化、艺术、体育等领域内有一定的相关从业经验，自身有一定的专长，并有意愿和能力在加拿大继续从事相关领域工作，为加拿大文化、艺术、体育做出一定贡献的申请人。该项目申请要求简单、流程简便、申请周期快、一步到位全家获得加拿大永居身份。
              </mdb-card-text>
              <a class="dark-grey-text pt-1 flex-row-reverse">
                <h5 class="p-2 text-right" waves @click="$router.push('/ca/cazigu')">查看详情
                  <mdb-icon icon="angle-double-right"/>
                </h5>
              </a>
            </mdb-card-body>
          </mdb-card>
        </mdb-col>

      </mdb-row>
    </mdb-container>


  </div>
</template>

<script>
import { animateOnScroll } from 'mdbvue'

export default {
  name: 'HomeCa',
  directives: {
    animateOnScroll
  }
}
</script>

<style>
.opacityOuterCa {
  background: rgba(0, 0, 0, 0.1) !important;
  background: #fff;
  filter: Alpha(opacity=10);
}
</style>
